// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import OECommentOldTemplate from '@front/templates/OECommentOldTemplate.html';
import { ContainerControl } from '../../elements/ContainerControl';
import { ControlsTypes } from '../../UtilsClasses/FactoryConstants';
import { Resources } from '@shared/localizations/Resources';
import { popupErrorHandler } from '@shared/utils/AppHandlers';
export class OECommentOld extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.OEComment;
    }
    oninit() {
        super.oninit();
        this.localize();
        this.on('focus', this.onFocus.bind(this));
    }
    oncomplete() {
        super.oncomplete();
        if (this.get('needValidateEmpty')) {
            this.initCommentText = this.get('userComment') || '';
            this.observeUserComment();
        }
    }
    getAbsoluteRectangle() {
        const root = this.find('div');
        if (!root)
            return new Rectangle(0, 0, 0, 0);
        const scrollLeft = window.scrollX || window.pageXOffset;
        const scrollTop = window.scrollY || window.pageYOffset;
        const { left, top, width, height } = root.getBoundingClientRect();
        const right = Array.from(root.children).find((el) => { var _a; return (_a = el.classList) === null || _a === void 0 ? void 0 : _a.contains('oe-selector-right'); });
        if (right) {
            const r = right.getBoundingClientRect();
            return new Rectangle(r.left + scrollLeft, r.top + scrollTop, width, height);
        }
        return new Rectangle(left + scrollLeft, top + scrollTop, width, height);
    }
    localize() {
        void this.set({
            label: Resources.getResource('panel.newOrderEntry.Comment'),
            tooltip: Resources.getResource('panel.newOrderEntry.Comment.ToolTip'),
            errorText: Resources.getResource('panel.newOrderEntry.careCommentTextboxError')
        });
    }
    showPopupError(errorText) {
        if (!this.get('focused') || !isValidString(errorText))
            return;
        popupErrorHandler.Show(this, errorText, '');
    }
    onteardown() {
        popupErrorHandler.Hide(this);
    }
    lostFocus() {
        super.lostFocus();
        popupErrorHandler.Hide(this);
        const userComment = this.get('userComment');
        if (!isValidString(userComment) && this.initCommentText !== userComment) {
            void this.set('userComment', this.initCommentText);
        }
    }
    observeUserComment() {
        this.observe('userComment', (value = '') => {
            const isUserCommentNotEmpty = isValidString(value);
            const error = isUserCommentNotEmpty ? '' : this.get('errorText');
            void this.set({ error, isUserCommentNotEmpty });
            if (error && this.get('focused')) {
                this.showPopupError(error);
            }
            else {
                popupErrorHandler.Hide(this);
            }
        });
    }
    onFocus() {
        const error = this.get('error');
        if (error && this.get('focused')) {
            this.showPopupError(error);
        }
    }
}
ContainerControl.extendWith(OECommentOld, {
    template: OECommentOldTemplate,
    initCommentText: '',
    data: () => ({
        label: '',
        maxLength: 128,
        userComment: '',
        showLabel: true,
        error: '',
        needValidateEmpty: false
    })
});
